import * as React from 'react';
import styled from 'styled-components';

import { PANE_MINWIDTH, PANE_NARROW } from '../../types/Constants';

interface IProps {
  children?: React.ReactNode;
}

const Chips = styled.div`
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: start;
`

const Controls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 34px;
  gap: 8px;
`

const SearchFilterStyled = styled.div`
  width: calc(${PANE_NARROW} - 60px);
  min-width: calc(${PANE_MINWIDTH} - 60px);
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 8px;
`

const SearchFilter = (props: IProps) => <SearchFilterStyled {...props}/>

SearchFilter.Chips = Chips;
SearchFilter.Controls = Controls;

export { SearchFilter }
